export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'xinli-dongji',
    name: '心理动机',
    description: '深入探讨换妻行为背后的心理驱动力，从性心理学、情感需求、夫妻关系动力学等多维度解析参与者的内在动机。',
    icon: 'ri-psychotherapy-line',
    color: 'primary',
    articleCount: 8,
  },
  {
    slug: 'anquan-shouze',
    name: '安全守则',
    description: '全面梳理换妻活动中必须遵守的安全规范，包括身体健康防护、隐私保护策略、情感界限管理等核心安全准则。',
    icon: 'ri-shield-check-line',
    color: 'accent',
    articleCount: 10,
  },
  {
    slug: 'falv-bianjie',
    name: '法律边界',
    description: '客观分析中国及国际主要法域下与换妻行为相关的法律条文与司法实践，帮助读者明确法律红线与灰色地带。',
    icon: 'ri-scales-3-line',
    color: 'secondary',
    articleCount: 6,
  },
  {
    slug: 'shequn-wenhua',
    name: '社群文化',
    description: '全景呈现换妻社群的内部文化特征，包括圈内术语、社交礼仪、活动形式、线上线下社群生态与发展历程。',
    icon: 'ri-group-line',
    color: 'primary',
    articleCount: 9,
  },
  {
    slug: 'jingyan-fenxiang',
    name: '经验分享',
    description: '汇集换妻实践者的真实经历与感悟，涵盖初次体验、长期关系维护、情感波动应对、退圈思考等多元化视角。',
    icon: 'ri-chat-heart-line',
    color: 'accent',
    articleCount: 7,
  },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});